// Banners
import Banner1 from '../images/banners/banner_1.png';
import Banner2 from '../images/banners/banner_2.png';
import Banner3 from '../images/banners/banner_3.png';
export const Images = {
    Banner1,
    Banner2,
    Banner3
};
const shimmer = (w, h) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#111A41" offset="20%" />
      <stop stop-color="#111A45" offset="50%" />
      <stop stop-color="#111A41" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#111A41" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;
const toBase64 = (str) => typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
export const ShimmerURL = `data:image/svg+xml;base64,${toBase64(shimmer(700, 475))}`;
